import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ResultCard from "@/components/ResultCard";
import ResultCardSkeleton from "@/components/ResultCardSkeleton";
import FAQSection from "@/components/FAQSection";
import StructuredData from "@/components/StructuredData";

import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { useLotteryResults } from "@/hooks/useLotteryResults";

const TicaHoy = () => {
  const { data: results, isLoading } = useLotteryResults(0);
  const costaRicaResults = results?.costaRicaResults || [];

  const faqs = [
    {
      question: "¿Qué salió hoy en Costa Rica?",
      answer: "Los resultados de hoy de los Tiempos JPS de Costa Rica se muestran arriba, actualizados para las 1pm, 4:30pm y 7:30pm. Incluyen el número ganador, el tipo especial (Bolita Blanca o Reventado) y el número final."
    },
    {
      question: "¿A qué hora salen los Tiempos de Costa Rica?",
      answer: "Los Tiempos JPS tienen tres sorteos diarios: a la 1:00 PM, 4:30 PM y 7:30 PM, hora de Costa Rica."
    },
    {
      question: "¿Qué significa Bolita Blanca y Reventado?",
      answer: "La Bolita Blanca y el Reventado (Bolita Roja) son indicadores especiales en los Tiempos JPS. Determinan diferentes categorías de premios y son parte esencial del resultado."
    },
  ];

  const today = new Date().toLocaleDateString('es-ES', { 
    timeZone: 'America/Costa_Rica',
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <>
      <StructuredData
        title="Resultados Tiempos JPS Costa Rica Hoy"
        description="Resultados actualizados de los Tiempos JPS de Costa Rica - Sorteos de 1pm, 4:30pm y 7:30pm"
        results={costaRicaResults}
        country="costa-rica"
      />
      
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1 container mx-auto px-4 py-8">
          <header className="text-center mb-12">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 text-costa-rica">
              🇨🇷 Tiempos Tica Hoy: resultados de Nuevos Tiempos de Costa Rica
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-2">
              Resultados de los Tiempos JPS
            </p>
            <p className="text-sm text-muted-foreground capitalize mb-4">{today}</p>
          </header>

          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <Button asChild variant="default">
              <Link to="/tiempos-tica-hoy">Hoy</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/que-salio-ayer-en-tiempos-jps">Ayer</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/tica-antier">Antier</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">🇳🇮 Ver Nicaragua</Link>
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
            {isLoading ? (
              <>
                <ResultCardSkeleton country="costa-rica" />
                <ResultCardSkeleton country="costa-rica" />
                <ResultCardSkeleton country="costa-rica" />
              </>
            ) : costaRicaResults.length > 0 ? (
              costaRicaResults.map((result, index) => (
                <ResultCard
                  key={index}
                  country="costa-rica"
                  {...result}
                />
              ))
            ) : (
              <p className="text-center text-muted-foreground col-span-full">No hay resultados disponibles para hoy.</p>
            )}
          </div>

          <FAQSection faqs={faqs} />

          <article className="mt-16 max-w-3xl mx-auto prose prose-sm">
            <h2>Tiempos Tica Hoy: ¿qué salió en los Tiempos JPS?</h2>
            <p>
              Consulta los resultados más recientes de los Tiempos JPS de Costa Rica. 
              Actualizamos los números ganadores inmediatamente después de cada sorteo 
              de la 1pm, 4:30pm y 7:30pm.
            </p>
            <p>
              Cada resultado incluye el número ganador (00-99), el indicador especial 
              (Bolita Blanca o Reventado) y el número final (00-99). Verifica si tu 
              número salió premiado hoy.
            </p>
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default TicaHoy;
